import {Component, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {User} from "src/app/auth/auth.model";
import {UserSuperAdminDialogComponent} from "./user-super-admin-dialog/user-super-admin-dialog.component";
import {UserSuperAdminService} from "./user-super-admin.service";
import {UsersApiService} from "../../api/users-api.service";
import {Router} from "@angular/router";
import { NoopScrollStrategy } from "@angular/cdk/overlay";
import { MessageService } from "src/app/utils/message/message.service";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";

@Component({
  selector: 'app-user-super-admin',
  templateUrl: './user-super-admin.component.html',
  styleUrls: ['./user-super-admin.component.scss']
})
export class UserSuperAdminComponent {

  items: any;
  originalItems: User[];
  filteredItems: User[];
  customerNumberSearch: string = '';

  displayedColumns: string[] = ['customerNumber', 'customerName', 'username', 'fullName', 'role', 'actions'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('userPaginator') userPaginator: MatPaginator;

  constructor(
    private userSuperAdminService: UserSuperAdminService,
    private usersApi: UsersApiService,
    public dialog: MatDialog,
    private router: Router,
    private message: MessageService,
    private languagePickerService: LanguagePickerService,
  ) {
    this.fetch();
  }

  fetch() {
    this.usersApi.search({
      "count": 5000,
      "query": {},
      "startIndex": 0
    }).subscribe(response => {
      this.originalItems = this.filteredItems = response.result;
      this.items = new MatTableDataSource(response.result);
      if (this.items != undefined) {
        this.items.sort = this.sort;
        this.items.paginator = this.userPaginator;
      }
    });
  }

  sortData(sort: Sort) {
    const data = this.filteredItems.slice();

    if (!sort.active || sort.direction === '') {
      this.filteredItems = data;
      return;
    }

    this.filteredItems = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'customerNumber': return compare(a.account.customerNumber, b.account.customerNumber, isAsc);
        case 'customerName': return compare(a.account.customerName, b.account.customerName, isAsc);
        case 'username': return compare(a.username, b.username, isAsc);
        case 'fullName': return compare(a.fullName, b.fullName, isAsc);
        case 'role': return compare(a.role, b.role, isAsc);
        default: return 0;
      }
    });
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  saveUpdateUser(user: User) {
    return this.userSuperAdminService.saveUpdate(user);
  }

  openNewUserDialog(): void {
    const dialogRef = this.dialog.open(UserSuperAdminDialogComponent, {
      width: '300px',
      scrollStrategy: new NoopScrollStrategy()
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateUser(result.data).subscribe((response) => {
          if (response.success) {
            this.message.info("admin.users.saveSuccess");
            this.fetch();
          } else {
            this.message.error(response.httpError.message);
          }
        });
      }
    });
  }

  openEditUserDialog(item: User): void {
    const dialogRef = this.dialog.open(UserSuperAdminDialogComponent, {
      width: '300px',
      data: {item: item},
      scrollStrategy: new NoopScrollStrategy()
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateUser(result.data).subscribe((response) => {
          if (response.success) {
            this.message.info("admin.users.saveSuccess");
            this.fetch();
          } else {
            this.message.error(response.httpError.message);
          }
        });
      }
    });
  }

  deleteUser(row: User): void {
    this.userSuperAdminService.delete(row).subscribe((response) => {
      if (response.success) {
        this.message.info("admin.users.deleteSuccess");
        this.fetch();
      } else {
        this.message.error(response.httpError.message);
      }
    });
  }

  search() {
    if (this.customerNumberSearch === '') {
      this.filteredItems = this.originalItems;
    } else {
      this.filteredItems = this.originalItems.filter(item => item.account.customerNumber === this.customerNumberSearch);
    }
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  private reInitTableSortPaginator() {
    this.items.sort = this.sort;
    this.items.paginator = this.userPaginator;
  }

  goBack() {
    this.router.navigate(['/sa/home']);
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}